// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XDWdwdS5VBCwZ9 {
  color: var(--ds-text-subtle, #44546f);
  font-weight: var(--ds-font-weight-regular, 400);
}
.vxRcirbzMct98x {
  margin-bottom: var(--ds-space-050, 4px);
  color: var(--ds-text-danger, #ae2a19);
  font-weight: var(--ds-font-weight-bold, 700);
}
`, ""]);
// Exports
export var tosLabel = `XDWdwdS5VBCwZ9`;
export var error = `vxRcirbzMct98x`;
export default ___CSS_LOADER_EXPORT___;
